import { Site } from '../../core/modules/sites/Site';
import { SeasonalEvent, SeasonalEventMerchant } from '../../core/types/SeasonalEvent';
import { EventBattle } from '../../types/Battle';

import { getSeasonalMerchantCustomTrackingId } from './getSeasonalMerchantCustomTrackingId';

export const getSeasonalMerchantsWithCustomTrackingId = async (
  event: SeasonalEvent,
  battle: EventBattle,
  site: Site,
  area: string,
  articleType?: string,
  articleCategory?: string,
): Promise<SeasonalEventMerchant[]> => {
  const trackedMerchantsPromises = event.merchants.map(async (merchant) => {
    let customTrackingId: string;
    try {
      customTrackingId = await getSeasonalMerchantCustomTrackingId(
        site,
        merchant,
        area,
        battle,
        articleType,
        articleCategory,
      );
    } catch (_) {
      return merchant;
    }

    return {
      ...merchant,
      customTrackingId,
    };
  });

  return trackedMerchantsPromises && Promise.all(trackedMerchantsPromises);
};
